// extracted by mini-css-extract-plugin
export default {"wideoWrapper":"styles__wideoWrapper___OAO4w","modal":"styles__modal___roh_g"};